import { SVGProps } from 'react';

const FoldHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 12h6M5 9l3 3-3 3m17-3h-6m3 3-3-3 3-3m-7-7v2m0 4v2m0 4v2m0 4v2"
    />
  </svg>
);
export default FoldHorizontal;
